import { render, staticRenderFns } from "./CreateNewUsergroupDialog.vue?vue&type=template&id=21fce5cd&scoped=true&lang=pug"
import script from "./CreateNewUsergroupDialog.vue?vue&type=script&lang=js"
export * from "./CreateNewUsergroupDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateNewUsergroupDialog.vue?vue&type=style&index=0&id=21fce5cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fce5cd",
  null
  
)

export default component.exports